<template>
  <div class="admin-layout">
    <SideBar :open="sidebarOpen" @navigate="sidebarOpen = false" />
    <div
      v-if="sidebarOpen"
      class="sidebar-backdrop"
      @click="sidebarOpen = false"
    ></div>
    <div class="admin-content">
      <Header @toggle="sidebarOpen = !sidebarOpen" />
      <main class="admin-page">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import Header from "../components/Header.vue";
import SideBar from "../components/SideBar.vue";

const sidebarOpen = ref(false);
</script>

<style scoped>
.sidebar-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  z-index: 900;
}
@media (min-width: 993px) {
  .sidebar-backdrop {
    display: none;
  }
}
</style>
